<mat-card>
    <mat-card-header>
      <mat-card-title>Configuración de Persona con {{'UnidadFuncional' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      </div>

      <ng-container *ngIf="canView">

        <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" hideToggle="true">

          <br/>

          <form [formGroup]="searchForm">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                  <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="ComunidadId">
                    <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <button mat-raised-button color="primary" [disabled]="isSearching || isSaving" (click)="searchUnidadesFuncionales()" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
                </div>
              </div>

            </div>

          </form>

        </mat-expansion-panel>

        <br/>

        <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" hideToggle="true">

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
            <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
            <div fxFlex=40 fxFlex.xs=100 class="flex-item">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <button mat-raised-button (click)="executeImportFile()" *ngIf="showImport" color="primary" class="zb-button" style="margin-right: 5px;">Realizar Importación</button>
                <button mat-raised-button (click)="executeExpoFile()" *ngIf="hasComunidadSelected()" class="zb-button" style="margin-right: 5px;">Exportar Datos</button>
              </div>
            </div>

            <div fxFlex=60 fxFlex.xs=100 class="flex-item" *ngIf="hasComunidadSelected()">
              <div fxLayout="row-reverse stretch" fxLayout.xs="column">
                <button mat-raised-button (click)="collapseAll()" class="zb-button" style="margin-right: 5px;">- Colapsar Todo</button>
                <button mat-raised-button (click)="expandAll()" class="zb-button" style="margin-right: 5px;">+ Expandir Todo</button>
              </div>
            </div>

            <div *ngIf="hasComunidadSelected()" fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center center" style="margin-top: 10px; text-align: center; color: indianred;">
              <mat-label>
                <i class="fa fa-exclamation-triangle fa-1x"></i>
                Tene en cuenta que los cambios tendrán efecto cuando presiones el botón <i><b>Guardar Cambios</b></i>, ubicado al final de la pantalla
              </mat-label>
            </div>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <ejs-grid #grid [dataSource]='data' [childGrid]='childGrid' [allowPaging]="true" [allowSorting]="true" (dataBound)='onDataBound()'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
              <e-columns>
                <e-column field='UnidadFuncionalCodigo' headerText='Código' width=90></e-column>
                <e-column field='UnidadFuncionalNumero' headerText='Número' width=90></e-column>
                <e-column field='TipoUnidad' headerText='Tipo Unidad' width=90></e-column>
                <e-column field='CantidadAmbientes' headerText='Ambientes' width=90></e-column>
                <e-column headerText='Acciones' width=40>
                  <ng-template #template let-data>
                    <a (click)='onUfPersonAdd(data)' style="cursor: pointer; margin-right: 5px;" title="Agregar Persona"><i class="fa fa-plus"></i></a>
                    <a (click)='onUfView(data)' *ngIf="canViewUf" style="cursor: pointer; margin-right: 5px;" title="Ver Unidad Funcional"><i class="fa fa-eye"></i></a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
            <ng-template #childGridActionTemplate let-data>
              <a (click)='onPersonaRelacionView(data)' style="cursor: pointer; margin-right: 5px;" title="Ver Datos Persona"><i class="fa fa-eye"></i></a>
              <a (click)='onPersonaRelacionDelete(data)' style="cursor: pointer; margin-right: 5px;" title="Eliminar Relación de Persona"><i class="fa fa-trash"></i></a>
              <a *ngIf="data.PuedeEnviarInvitacion" (click)='sendInvite(data)' style="cursor: pointer; margin-right: 5px;" title="Enviar Invitación"><i class="fa fa-envelope"></i></a>
            </ng-template>
          </div>

        </mat-expansion-panel>

      </ng-container>

    </mat-card-content>

    <mat-card-actions style="margin-bottom: 20px;">
      <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button (click)="onGuardar()" *ngIf="canView && hasComunidadSelected()" [disabled]="isSaving || isSearching" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar Cambios'}}</button>
        <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canView ? 'Cancelar' : 'Cerrar'}}</button>
      </div>
    </mat-card-actions>

  </mat-card>
